import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'
import { ErrorBoundary } from '@/components/ui/errors'
import { authClient } from '@/lib/auth-client'
import type { RouteStaticData } from '@/lib/router/breadcrumbs'

export const Route = createFileRoute('/_app/admin')({
  beforeLoad: async () => {
    const session = await authClient.getSession()
    const user = (session as { user?: { role?: string } | null } | null)?.user

    if (!user) {
      throw redirect({
        to: '/auth/$authView',
        params: { authView: 'sign-in' },
      })
    }

    if (user.role !== 'admin') {
      throw redirect({ to: '/', replace: true })
    }
  },
  component: AdminLayout,
  staticData: {
    breadcrumbs: [{ label: 'Admin', href: '/admin' }],
  } satisfies RouteStaticData,
})

function AdminLayout() {
  return (
    <ErrorBoundary>
      <Outlet />
    </ErrorBoundary>
  )
}
